import React, { useState } from "react";
import "./ReviewSection.css";

const reviews = [
  {
    place: "Goa Beach Resort",
    stars: 5,
    text: "The resort was absolutely amazing! Spacious rooms with sea views, delicious seafood, and the beach just a few steps away. .",
    author: "Amania",
    image: "/assets/image9.jpg",
    bgImage: "/assets/image8.jpg",
  },
  {
    place: "Taj Mahal, Agra",
    stars: 5,
    text: "One of the most beautiful monuments I have ever seen. The detailing in marble is incredible and the view during sunrise is magical.",
    author: "Pravesh Sharma",
    image: "/assets/image11.jpg",
    bgImage: "/assets/image12.jpg",
  },
  {
    place: "Jaipur - Hawa Mahal",
    stars: 4,
    text: "A stunning palace with a unique honeycomb design. The pink city vibes make it unforgettable.",
    author: "Robert Slang",
    image: "/assets/image10.jpg",
    bgImage: "/assets/image14.jpg",
  },
  {
    place: "Kerala Backwaters",
    stars: 5,
    text: "The houseboat stay was peaceful and scenic. Truly a heaven on earth with lush greenery and calm waters.",
    author: "Ananya Nair",
    image: "/assets/reviewer3.jpg",
    bgImage: "/assets/kerala.jpg",
  },
];

export default function ReviewSection() {
  const [current, setCurrent] = useState(0);

  const nextReview = () => {
    setCurrent((prev) => (prev + 1) % reviews.length);
  };

  const prevReview = () => {
    setCurrent((prev) => (prev - 1 + reviews.length) % reviews.length);
  };

  return (
    <>
      {/* ---------------- Review Section ---------------- */}
      <div className="review-container">
        {/* Left side image */}
        <div className="review-left">
          <img
            src={reviews[current].bgImage}
            alt={reviews[current].place}
            className="review-img"
          />
        </div>

        {/* Right side content */}
        <div className="review-right">
          <h2 className="review-title">Our Top Reviews</h2>
          <h3 className="review-subtitle">{reviews[current].place}</h3>

          {/* Stars */}
          <div className="review-stars">
            {"★".repeat(reviews[current].stars)}
          </div>

          {/* Text */}
          <p className="review-text">{reviews[current].text}</p>

          {/* Reviewer */}
          <div className="review-author">
            <img
              src={reviews[current].image}
              alt={reviews[current].author}
              className="author-img"
            />
            <span className="author-name">{reviews[current].author}</span>
          </div>

          {/* Slider Buttons */}
          <div className="slider-buttons">
            <button onClick={prevReview}>&#10094;</button>
            <button onClick={nextReview}>&#10095;</button>
          </div>
        </div>
      </div>

      {/* ---------------- Adventure Section ---------------- */}
      <div className="adventure-container">
        {/* Left side text */}
        <div className="adventure-left">
          <h3 className="adventure-subtitle">adventure</h3>
          <h2 className="adventure-title">Dare To Explore</h2>
          <p className="adventure-text">
            Exploring means learning. Bring new experiences from each journey. 
            Meet different cultures, traditions and landscapes. Choose your next 
            destination and start your trip.
          </p>
          <button className="adventure-btn">SEE MORE</button>
        </div>

        {/* Right side image */}
        <div className="adventure-right">
          <img
            src="/assets/image15.jpg"   // apni image ka path replace karein
            alt="Adventure"
            className="adventure-img"
          />
        </div>
      </div>
    </>
  );
}
